import styled from 'styled-components'

const ComponentStyled = styled.div`
  .wish-finish-box {
    max-width: 700px;
    margin: 0 auto;
    position: relative;

    .finish-title {
      font-family: 'Playfair Display';
      font-weight: 900;
      font-size: 48px;
      line-height: 48px;
      letter-spacing: 0.01em;
      color: ${({ theme }) => theme.colors.black};
      margin-bottom: 10px;
      text-align: center;
    }

    .finish-desc {
      font-family: 'Cabin';
      font-weight: 600;
      font-size: 18px;
      line-height: 29px;
      color: ${({ theme }) => theme.colors.black};
      margin-bottom: 25px;
      text-align: center;
    }

    .wish-wrapper {
      max-width: 380px;
      margin: 0 auto;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    .wish-finish-box {
      .finish-title {
        font-size: 24px;
        line-height: 24px;
      }

      .finish-desc {
        font-size: 14px;
        line-height: 16px;
      }

      .wish-wrapper {
        max-width: 100%;
      }
    }
  }
`

export default ComponentStyled
